
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle, AlertCircle, Info, AlertTriangle, Loader2, X } from 'lucide-react';
import { useUIState } from '@/core/UIStateProvider';

const iconMap = {
    success: CheckCircle,
    error: AlertCircle,
    info: Info,
    warning: AlertTriangle,
};

const styleMap = {
    success: 'bg-green-50 border-green-200 text-green-800',
    error: 'bg-red-50 border-red-200 text-red-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
};

export const NotificationToast: React.FC = () => {
    const { notifications, clearNotification } = useUIState();

    return (
        <div className="fixed bottom-4 right-4 z-50 space-y-2">
            <AnimatePresence mode="popLayout">
                {notifications.map((notification) => {
                    const Icon = notification.type === 'info' && notification.message.toLowerCase().includes('saving')
                        ? Loader2
                        : iconMap[notification.type];
                    const isLoading = Icon === Loader2;

                    return (
                        <motion.div
                            key={notification.id}
                            initial={{ opacity: 0, y: 20, scale: 0.95 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                            transition={{ type: 'spring', stiffness: 500, damping: 40 }}
                        >
                            <div
                                className={`flex items-center space-x-2 px-4 py-3 rounded-lg shadow-lg border min-w-[300px] ${styleMap[notification.type]
                                    }`}
                            >
                                <Icon
                                    size={20}
                                    className={isLoading ? 'animate-spin' : ''}
                                />
                                <span className="font-medium flex-1">{notification.message}</span>
                                <button
                                    onClick={() => clearNotification(notification.id)}
                                    className="ml-2 hover:opacity-70 transition-opacity"
                                >
                                    <X size={16} />
                                </button>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>
        </div>
    );
};